export default "__VITE_ASSET__lUibdjhd__"